<script>
    import {setFocusTo} from "../lib/lib";

    export let id = '';
    export let value = '';
    export let placeholder = '';
    export let required = false;

    let viewPassword = false;

    const togglePassword = () => {
        viewPassword = !viewPassword;
        setFocusTo(id);
    }
</script>
<div class="input-group">
    {#if viewPassword}
        <input type="text" class="form-control bg-white" id={id} name="password" bind:value={value} {placeholder} {required}>
    {:else}
        <input type="password" class="form-control bg-white" id={id} name="password" bind:value={value} {placeholder} {required}>
    {/if}
    <a href="#toggle" class="btn btn-default d-flex align-items-center" on:click|preventDefault|stopPropagation="{ togglePassword }">
        *
    </a>
</div>

<style>
    .input-group {
        display: flex;
    }
</style>